import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
})
export class CardComponent {
    @Input() public isHeader = true;
    @Input() public isFooter = true;
    @Input() public isDialog = false;
}
